import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';

const StyledTypography = withStyles({
  root: {
    marginBottom: 20,
    color: '#373737',
    fontSize: 30,
  },
})(Typography);

function SubTitle({ children }) {
  return <StyledTypography>{children}</StyledTypography>;
}

SubTitle.propTypes = {
  children: PropTypes.string.isRequired,
};

export default SubTitle;
